<template>
  <div class="certificate">
    <div class="header">
      <img class="logo" :src="logo" alt="Training Port" />
    </div>
    <div class="content">
      <p class="name">
        {{ certificate.user.fullName }}
      </p>
      <p class="description">
        Given in recognition of your successful completion of the
      </p>
      <p class="topic">
        {{ certificate.topic.name }}
        <small class="text-2xl">Version: {{ certificate.topic.version }}</small>
      </p>
      <p class="type">On-line Training</p>
      <p class="date">
        Date of Completion: {{ formatDate(certificate.completed_at) }}
      </p>
    </div>
    <div class="footer">
      <!-- <p class="hash">
        {{ certificate.hash }}
      </p> -->
    </div>
  </div>
</template>

<script>
import label from "@consts/label";
import { mapGetters, mapActions } from "vuex";
import HelperDate from "@helpers/dates";

export default {
  props: {
    certificate: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      logo: label.companyWhiteVersionLogo,
    };
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
  },
  async mounted() {
    try {
      this.$wait.start(this._uid);
    } catch (error) {
      this.$wait.end(this._uid);
    } finally {
      setTimeout(window.print, 800);
      this.$wait.end(this._uid);
    }
  },
  methods: {
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("errorStore", ["addNewError"]),
    formatDate(date) {
      return HelperDate.formatDate(
        date,
        HelperDate.formats.CERTIFICATE_DATE_FORMAT
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.certificate {
  text-align: center;
  .header {
    background-image: linear-gradient(#1a5b7c, #ffffff) !important;
    background-image: -o-linear-gradient(#1a5b7c, #ffffff) !important;
    background-image: -webkit-linear-gradient(#1a5b7c, #ffffff) !important;
    min-height: 250px;
    .logo {
      text-align: center;
      padding: 50px;
      margin: 0 auto;
    }
  }

  .content {
    text-align: center;
    font-style: italic;
    font-weight: 300;
    font-size: 1.2em;

    .name {
      font-style: normal;
      font-weight: 600;
      font-size: 1.5em;
    }

    .description {
      font-size: 1.3em;
    }

    .topic {
      font-weight: 600;
      font-size: 1.2em;
    }

    .type {
      font-weight: 600;
      font-size: 1.1em;
    }

    .date {
      font-weight: 600;
      font-size: 0.9em;
    }
  }

  .footer {
    margin-top: 75px;
    text-align: center;

    .signature {
      font-size: 1.2em;
    }

    .hash {
      font-size: 1em;
    }
  }
}

@media print {
  @page {
    size: letter portrait;
    max-height: 99%;
    max-width: 99%;
  }
}
</style>
